<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div style=" overflow-x: hidden">
        <v-row style="padding:1% 2%; height: 100px;">
          <v-col xs="10" sm="10" md="10" lg="10">
            <h2>รับของรางวัล</h2>
          </v-col>
        </v-row>
        <!-- <v-divider style="padding-top:0; magin: 0px 0px"></v-divider> -->
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row style="padding-top: 20px;justify-content: center;">
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    class="padding-colH"
                  >
                    <p style="margin: 0px 0px">
                      รหัสของรางวัล <span style="color: red;">*</span>
                    </p>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="checkCode"
                      label=""
                      solo
                      required
                      :append-outer-icon="'mdi-magnify'"
                      @click:append-outer="check()"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="status === true">
                  <v-col>
                    <v-card>
                      <v-row>
                        <v-col>
                          <v-card elevation="2">
                            <v-img
                              :src="d.pictureUrl"
                              width="250"
                              :aspect-ratio="16 / 9"
                            ></v-img>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-row>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12">{{
                              d.name
                            }}</v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12">{{
                              thaiFormattedDate(d.endDate)
                            }}</v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12">{{
                              d.name
                            }}</v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12">{{
                              d.name
                            }}</v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
export default {
  data () {
    return {
      session: this.$session.getAll(),
      //   path: '/qrcode/', // Path Model
      //   returnLink: '/Tool/CollectQRCode',
      valid: true,
      checkCode: '',
      d: [],
      status: false
    }
  },
  mounted () {},
  methods: {
    check () {
      axios
        .get(
          this.DNS_IP +
            '/rewardCode/getData?shopId=' +
            this.session.data.shopId +
            '&redeemStatus=get&rewardCode=' +
            this.checkCode
        )
        .then(res => {
          let rs = res.data
          if (rs.message === 'No data found' || rs.status === false) {
            this.$swal('ข้อมูลไม่ถูกต้อง', 'กรุณากรอกรหัสให้ถูกต้อง', 'warning')
          } else {
            console.log('res', res.data)
            this.d = rs[0]
            this.status = true
          }
        })
    }
  }
}
</script>
<style scoped>
.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f2f4f9 !important;
}
.padding-colH {
  padding: 5px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/Redeem.vue